import React from 'react'
import { BsCursorFill, BsPhoneFill, BsClockFill, BsFacebook } from "react-icons/bs";
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}
export default function Contact() {
  // const [value, setValue] = React.useState(0);

  // const handleChange = (event, newValue) => {
  //   setValue(newValue);
  // };
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className="mx-auto max-w-7xl px-4 py-6 mt-2 sm:px-6 sm:py-1 lg:max-w-7xl lg:px-8 xl:max-w-screen-xl 2xl:max-w-7xl">
      <Box >
        <Tabs
          value={value}
          onChange={handleChange}
          variant="fullWidth"
          scrollButtons
          allowScrollButtonsMobile
          aria-label="scrollable force tabs example"
        >
          <Tab label="Thông tin liên hệ " {...a11yProps(0)} />
          <Tab label="Chính sách đổi hàng" {...a11yProps(1)} />
          <Tab label="Chính sách bảo mật" {...a11yProps(2)} />
        </Tabs>

        <TabPanel value={value} index={0}>
          <ol className=''>
            <p>
              <strong>Văn phòng:</strong>
            </p>
            <ul className=' space-y-1 p-2' >
              <li className='flex content-center pl-5'><BsCursorFill /><span className='pl-2'>153AB Nam Kỳ Khởi Nghĩa, P.Võ Thị Sáu, Q.3, Tp.HCM </span></li>
              <li className='flex content-center pl-5'><BsPhoneFill /><span className='pl-2'>VP: 028.39.307.900</span></li>
              <li className='flex content-center pl-5'><BsPhoneFill /><span className='pl-2'>Zalo: 0784.99.2000</span></li>
              <li className='flex content-center pl-5'><BsClockFill /><span className='pl-2'>Thứ 2 - Thứ 6: 8:00 - 16:00</span></li>
            </ul>
            <p>
              <strong>Mạng xã hội:</strong>
            </p>
            <ul className=' space-y-1 p-2' >
              <li className='flex content-center pl-5'><BsFacebook /><span className='pl-2'>Facebook: facebook.com/pt2000.com.vn</span></li>
            </ul>
            <p>
              <strong>Cửa hàng:</strong>
            </p>
            <ul className=' space-y-2 p-2' >
              <li className='flex content-center pl-5'><BsClockFill /><span className='pl-2'>Thứ 2 - Chủ nhật : 8:00 - 22:00</span></li>
              <li className='flex content-center pl-5'><BsCursorFill /><span className='pl-2 pr-3'>153AB Nam Kỳ Khởi Nghĩa, P.Võ Thị Sáu, Q.3, Tp.HCM </span><BsPhoneFill /><span className='pl-2'>028.39.307.753</span></li>
              <li className='flex content-center pl-5'><BsCursorFill /><span className='pl-2 pr-3'>137A Hai Bà Trưng, P.Võ Thị Sáu, Q.3, Tp.HCM </span><BsPhoneFill /><span className='pl-2'>028.38.243.278</span></li>
              <li className='flex content-center pl-5'><BsCursorFill /><span className='pl-2 pr-3'>249A Nguyễn Trãi, P.2, Q.5, Tp.HCM </span><BsPhoneFill /><span className='pl-2'>0898.131.939</span></li>
              <li className='flex content-center pl-5'><BsCursorFill /><span className='pl-2 pr-3'>767 Hậu Giang, P.11, Q.6, Tp.HCM </span><BsPhoneFill /><span className='pl-2'>0939.307.900</span></li>
              <li className='flex content-center pl-5'><BsCursorFill /><span className='pl-2 pr-3'>191 Lê Đại Hành, P.13, Q.11 Tp.HCM </span><BsPhoneFill /><span className='pl-2'>028.39.623.167</span></li>
              <li className='flex content-center pl-5'><BsCursorFill /><span className='pl-2 pr-3'>603 Cách Mạng Tháng 8, P.15, Q.10, Tp.HCM </span><BsPhoneFill /><span className='pl-2'>028.39.770.900</span></li>
              <li className='flex content-center pl-5'><BsCursorFill /><span className='pl-2 pr-3'>35-37 Lê Văn Sỹ, P.13, Q.Phú Nhuận, Tp.HCM </span><BsPhoneFill /><span className='pl-2'>028.39.914.123</span></li>
              <li className='flex content-center pl-5'><BsCursorFill /><span className='pl-2 pr-3'>46-48 Quang Trung, P.10, Q.Gò Vấp, Tp.HCM</span><BsPhoneFill /><span className='pl-2'>028.39.899.775</span></li>
              <li className='flex content-center pl-5'><BsCursorFill /><span className='pl-2 pr-3'>564 Quang Trung, P.11, Q.Gò Vấp, Tp.HCM</span><BsPhoneFill /><span className='pl-2'>028.35.891.248</span></li>
              <li className='flex content-center pl-5'><BsCursorFill /><span className='pl-2 pr-3'>883 Quang Trung, P.14, Q.Gò Vấp, Tp.HCM </span><BsPhoneFill /><span className='pl-2'>0932.310.090</span></li>
              <li className='flex content-center pl-5'><BsCursorFill /><span className='pl-2 pr-3'>233-235 Võ Văn Ngân, P.Linh Chiểu, Q.Thủ Đức, Tp.HCM</span><BsPhoneFill /><span className='pl-2'>0939.79.3443</span></li>
              <li className='flex content-center pl-5'><BsCursorFill /><span className='pl-2 pr-3'>101 Yersin, P.Phú Cường, Tp.Thủ Dầu Một, T.Bình Dương </span><BsPhoneFill /><span className='pl-2'>027.43.822.182</span></li>
              <li className='flex content-center pl-5'><BsCursorFill /><span className='pl-2 pr-3'>1549 Phạm Văn Thuận, P.Thống Nhất, Tp.Biên Hòa, T.Đồng Nai </span><BsPhoneFill /><span className='pl-2'>025.18.820.869</span></li>
              <li className='flex content-center pl-5'><BsCursorFill /><span className='pl-2 pr-3'>57 Lê Duẩn, P.Hải Châu 1, Tp.Đà Nẵng</span><BsPhoneFill /><span className='pl-2'>023.63.562.974</span></li>
              <li className='flex content-center pl-5'><BsCursorFill /><span className='pl-2 pr-3'>66-68 Lý Thánh Tôn, Tp.Nha Trang, T.Khánh Hòa</span><BsPhoneFill /><span className='pl-2'>025.83.814.586</span></li>
              <li className='flex content-center pl-5'><BsCursorFill /><span className='pl-2 pr-3'>115 Lý Thường Kiệt, Tp.Buôn Mê Thuột, T.Đắk Lắk </span><BsPhoneFill /><span className='pl-2'>026.23.841.574</span></li>
              <li className='flex content-center pl-5'><BsCursorFill /><span className='pl-2 pr-3'>69 Hùng Vương, Tp.Huế, T.Thừa Thiên Huế </span><BsPhoneFill /><span className='pl-2'>023.43.883.111</span></li>
              <li className='flex content-center pl-5'><BsCursorFill /><span className='pl-2 pr-3'>37 Nguyễn Văn Cừ, Tp.Vinh, T.Nghệ An </span><BsPhoneFill /><span className='pl-2'>023.83.580.001</span></li>
              <li className='flex content-center pl-5'><BsCursorFill /><span className='pl-2 pr-3'>E4 E5 E6 Tuyên Quang, Tp.Phan Thiết, T.Bình Thuận </span><BsPhoneFill /><span className='pl-2'>025.23.822.688</span></li>
              <li className='flex content-center pl-5'><BsCursorFill /><span className='pl-2 pr-3'>101 Bà Triệu, Q.Hai Bà Trưng, Tp.Hà Nội </span><BsPhoneFill /><span className='pl-2'>024.39.346.842</span></li>
              <li className='flex content-center pl-5'><BsCursorFill /><span className='pl-2 pr-3'>119 Chùa Bộc, Q.Đống Đa, Tp.Hà Nội </span><BsPhoneFill /><span className='pl-2'>024.35.641.839</span></li>
              <li className='flex content-center pl-5'><BsCursorFill /><span className='pl-2 pr-3'>7 Trần Thái Tông, Q.Cầu Giấy, Tp.Hà Nội</span><BsPhoneFill /><span className='pl-2'>024.37.689.664</span></li>

            </ul>
          </ol>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <div className=''>
            <p className=' font-bold text-xl pb-2'>Chính sách đổi hàng tại PT2000</p>
            <ul className=' space-y-4 p-2'>
              <li> Quý Khách có thể đổi hàng trực tiếp tại hệ thống cửa hàng PT2000 hoặc liên hệ với bộ phận bán hàng trực tuyến để được hướng dẫn. </li>
              <li>
                <p>Điều kiện đổi hàng:</p>
                <p className=' pl-5'> + 01 sản phẩm được đổi 01 lần. </p>
                <p className=' pl-5'> + Sản phẩm chưa qua sử dụng, còn nguyên nhãn, mác.</p>
                <p className=' pl-5'> + Quý khách vui lòng giữ hóa đơn khi đổi hàng tại cửa hàng.</p>
              </li>
              <li>
                <p>Thời hạn đổi hàng:</p>
                <p className=' pl-5'> + Quý khách hàng mua hàng được đổi hàng trong vòng 7 ngày kể từ ngày mua hàng. </p>
                <p className=' pl-5'> + Quý khách hàng ở xa không tiện trong việc đổi hàng vui lòng liên hệ trước với nhân viên tư vấn bán hàng.</p>
                <p className=' pl-5'> + Sản phẩm nội y (đồ lót): Không được đổi hàng.</p>
              </li>
              <li>
                <p>Lưu ý:</p>
                <p className=' pl-5'> + Sản phẩm khuyến mãi, giảm giá không được áp dụng chính sách đổi hàng. </p>
                <p className=' pl-5'> + Sản phẩm (quần áo) đã cắt sửa, lên lai không được đổi hàng.</p>
                <p className=' pl-5'> + Sản phẩm đổi mới có giá trị bằng hoặc cao hơn, khách hàng thanh toán phần giá trị chênh lệch (nếu có).</p>
                <p className=' pl-5'> + Hàng đã mua không được trả lại.</p>
              </li>
            </ul>
          </div>
        </TabPanel>
        <TabPanel value={value} index={2}>
        <div className=''>
            <p className=' font-bold text-xl pb-2'>PT2000 luôn tôn trọng sự riêng tư, muốn bảo vệ thông tin cá nhân và thông tin thanh toán của khách hàng. “Chính sách bảo mật thông tin” dưới đây như một lời tuyên bố về cam kết mà chúng tôi thực hiện, nhằm tôn trọng và bảo vệ quyền lợi của người sử dụng.</p>
            <ul className=' space-y-4 p-2'>
              <li>
                <p className=' font-bold'>Mục đích và phạm vi thu thập thông tin</p>
                <p>Khi khách hàng thực hiện đặt hàng tại cửa hàng trực tuyến của PT2000, khách hàng phải cung cấp một số thông tin cần thiết như:</p>
                <p className=' pl-7'> - Họ tên </p>
                <p className=' pl-7'> - Số điện thoại</p>
                <p className=' pl-7'> - Địa chỉ</p>
              </li>
              <li>
                <p className=' font-bold'>Những thông tin trên sẽ được sử dụng cho một hoặc tất cả các mục đích sau đây:</p>
                <p className=' pl-7'> - Giao hàng quý khách đã mua sản phẩm qua website PT2000 </p>
                <p className=' pl-7'> - Thông báo về việc giao hàng và hỗ trợ khách hàng, chăm sóc khách hàng.</p>
                <p className=' pl-7'> - Cung cấp thông tin liên quan đến sản phẩm. Xử lý đơn đặt hàng và cung cấp dịch vụ và thông tin qua trang web của chúng tôi theo yêu cầu của quý khách.</p>
              </li>
              <li>
                <p className=' font-bold'>Phạm vi sử dụng thông tin</p>
                <p className=' pl-5'> Ngoài việc xử lý, hỗ trợ việc mua hàng của quý khách tại website PT2000, chúng tôi sẽ sử dụng thông tin quý khách cung cấp để hỗ trợ xác nhận và thực hiện các giao dịch tài chính liên quan đến các khoản thanh toán trực tuyến của quý khách; kiểm tra dữ liệu tải từ trang web của chúng tôi; cải thiện giao diện hoặc nội dung của các trang mục trên trang web, tùy chỉnh để dễ dàng hơn khi sử dụng; nhận diện khách đến thăm trang web; nghiên cứu về nhân khẩu học của người sử dụng; gửi đến quý khách thông tin mà chúng tôi nghĩ sẽ có ích hoặc do quý khách yêu cầu, bao gồm thông tin về sản phẩm và dịch vụ, với điều kiện quý khách đồng ý không phản đối việc được liên lạc cho các mục đích trên. </p>
              </li>
              <li>
                <p className=' font-bold'>Thời gian lưu trữ thông tin</p>
                <p className=' pl-5'> Thông tin khách hàng, cũng như các trao đổi giữa khách hàng và PT2000, đều được lưu trữ và bảo mật bởi hệ thống của công ty.</p>
                <p className=' pl-5'> Thời gian lưu trữ thông tin khách hàng bắt đầu từ khi khách hàng đặt hàng tại website PT2000. Khi quý khách hàng muốn ngừng lưu trữ có thể liên hệ với công ty để thực hiện ngừng lưu trữ thông tin.</p>
              </li>
              <li>
                <p className=' font-bold'>Phương tiện và công cụ để người dùng tiếp cận và chỉnh sửa dữ liệu cá nhân của mình</p>
                <p className=' pl-5'> Quý khách hàng có thể cập nhật thông tin bất cứ lúc nào bằng cách gọi điện thoại về số 0784.99.2000 hoặc nhắn tin vào zalo OA PT2000 hoặc nhắn tin vào fanpage PT2000</p>
              </li>
              <li>
                <p className=' font-bold'>Chia sẻ thông tin khách hàng</p>
                <p className=' pl-5'>PT2000 cam kết sẽ không chia sẻ thông tin của khách hàng cho bất kỳ một công ty nào khác ngoại trừ những công ty và các bên thứ ba có liên quan trực tiếp đến việc giao hàng. Chúng tôi có thể tiết lộ hoặc cung cấp thông tin cá nhân của quý khách trong các trường hợp thật sự cần thiết như sau:</p>
                <p className=' pl-7'> - Khi có yêu cầu của các cơ quan pháp luật.</p>
                <p className=' pl-7'> - Chia sẻ thông tin khách hàng với đối tác chạy quảng cáo như Google ví dụ như tiếp thị lại khách hàng dựa theo hành vi của khách hàng.</p>
                <p className=' pl-7'> - Nghiên cứu thị trường và các báo cáo phân tích và tuyệt đối không chuyển cho bên thứ ba.</p>
              </li>
            </ul>
          </div>
        </TabPanel>

      </Box>







    </div>
  )
}
